module.exports = __webpack_public_path__ + "static/img/pic_chevrolet@2x.3d5c050.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity_template/pic_chevrolet@2x.png
// module id = hNRT
// module chunks = 0